import { tiendasApi } from '../api'

export const cronogramaSlice = tiendasApi.injectEndpoints({
    endpoints: builder => ({
        getCronogramas: builder.mutation({
            query: () => ({
                url: 'web/cronograma',
                method: 'GET'
            })
        }),
    })
})

export const {
    useGetCronogramasMutation,
} = cronogramaSlice